import { de as extranetDataDisplayErrorPanel } from 'ViatoUi/Extranet/DataDisplay/ErrorPanel';
import { de as sharedFeedbackUserActionFeedback } from 'ViatoUi/Shared/Feedback/UserActionFeedback';

// Contains language vars that are the same across the entire application - like "back", "submit" etc.
const app = {
	feedback: {
		save: {
			error: 'Fehler beim Verarbeiten der Daten.',
			success: 'Ihre Änderungen wurden erfolgreich gespeichert!'
		},
		data: {
			processing: 'Daten werden verarbeitet.'
		}
	}
};

const de = {
	app,
	shared: {
		feedback: {
			userActionFeedback: sharedFeedbackUserActionFeedback
		}
	},
	extranet: {
		dataDisplay: {
			errorPanel: extranetDataDisplayErrorPanel
		}
	}
};

export default de;
